var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcUserProfileCheck({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.19635 2.26693C6.23906 2.26693 5.46302 3.04297 5.46302 4.00026C5.46302 4.95755 6.23906 5.73359 7.19635 5.73359C8.15365 5.73359 8.92969 4.95755 8.92969 4.00026C8.92969 3.04297 8.15365 2.26693 7.19635 2.26693ZM4.12969 4.00026C4.12969 2.30659 5.50268 0.933594 7.19635 0.933594C8.89003 0.933594 10.263 2.30659 10.263 4.00026C10.263 5.69393 8.89003 7.06693 7.19635 7.06693C5.50268 7.06693 4.12969 5.69393 4.12969 4.00026ZM0.929957 11.9999C0.930148 10.3064 2.30309 8.93359 3.99662 8.93359H8.79626C9.16445 8.93359 9.46292 9.23207 9.46292 9.60026C9.46292 9.96845 9.16445 10.2669 8.79626 10.2669H3.99662C3.03941 10.2669 2.2634 11.0428 2.26329 12.0001L2.26302 14.4003C2.26298 14.7685 1.96447 15.067 1.59628 15.0669C1.22809 15.0669 0.929646 14.7684 0.929688 14.4002L0.929957 11.9999ZM13.9249 9.12885C14.1853 8.86851 14.6074 8.86851 14.8678 9.12885C15.1281 9.3892 15.1281 9.81131 14.8678 10.0717L12.0678 12.8717C11.8074 13.132 11.3853 13.132 11.1249 12.8717L10.3249 12.0717C10.0646 11.8113 10.0646 11.3892 10.3249 11.1289C10.5853 10.8685 11.0074 10.8685 11.2678 11.1289L11.5964 11.4574L13.9249 9.12885Z",
    fill: "#116584"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcUserProfileCheck);
export default __webpack_public_path__ + "static/media/ic-user-profile-check.db848d5af84b26b06905cf4d0b9c05a3.svg";
export { ForwardRef as ReactComponent };